import { imageNames } from "@/src/constants/imageConstants.js";
import ChatBrowser from "@/src/views/projects/chats/side_panel/browser/ChatBrowser.vue";
import CreateNewChat from "@/src/views/projects/chats/side_panel/create/CreateNewChat.vue";

export const chatTabOptions = {
  ALL: "all",
  DMS: "dms",
  GROUPS: "groups",
  EXTERNAL: "external",
  ASSOCIATED: "associated",
  UNREAD: "unread",
  DRAFTS: "drafts",
};

export const chatTabs = [
  { id: chatTabOptions.ALL, title: "All" },
  { id: chatTabOptions.DMS, title: "DMs" },
  { id: chatTabOptions.GROUPS, title: "Groups" },
  { id: chatTabOptions.EXTERNAL, title: "External" },
  { id: chatTabOptions.ASSOCIATED, title: "Associated" },
  { id: chatTabOptions.UNREAD, title: "Unread" },
  { id: chatTabOptions.DRAFTS, title: "Drafts" },
];

export const chatViews = {
  BROWSER: "browser",
  CREATE_NEW: "create_new",
};

export const chatViewComponentMap = {
  [chatViews.BROWSER]: ChatBrowser,
  [chatViews.CREATE_NEW]: CreateNewChat,
};

export const chatTypes = {
  DM: "dm",
  SELF_DM: "self_dm",
  GROUP_DM: "group_dm",
  PUBLIC: "public",
  PRIVATE: "private",
  EXTERNAL: "external",
};

export const chatRecipientTypes = {
  GROUP: 0,
  ONE_ON_ONE: 1,
  GROUP_DM: 2,
};

export const chatToastTypes = {
  REACTION: "reaction",
  MENTION: "mention",
  THREAD_REPLY: "thread_reply",
  MESSAGE: "message",
};

export const chatGroupVisibilityOptions = {
  PUBLIC: "public",
  PRIVATE: "private",
  EXTERNAL: "external",
};

export const chatGroupVisibilityOptionDetails = [
  {
    value: chatGroupVisibilityOptions.PUBLIC,
    label: "Public",
    description:
      "Everybody in your workspace will be able to access this Group",
  },
  {
    value: chatGroupVisibilityOptions.PRIVATE,
    label: "Private",
    description:
      "You and specific people will be able to access this view. You can invite people anytime later",
  },
  {
    value: chatGroupVisibilityOptions.EXTERNAL,
    label: "External",
    description:
      "Share an invite link with people outside your workspace to join this group",
  },
];

export const PLACEHOLDER_GREETINGS = ["Say hello!", "Send a hi!"];

export const messageActions = {
  ADD_REACTION: "add_reaction",
  CREATE_TASK: "create_task",
  OPEN_THREAD: "open_thread",
  MORE_ACTIONS: "more_actions",
  EDIT_MESSAGE: "edit_message",
  FORWARD_MESSAGE: "forward_message",
};

export const HOME_GROUP_NAME = "Home";

export const WORKFLOW_USER_ID = -999;
export const WORKFLOW_MESSAGE_TYPE_PREFIX = "workflow:";

export const groupActions = {
  UPDATE_GROUP: "update_group",
  DELETE_GROUP: "delete_group",
};

export const getGroupActionDetails = (handlers) => [
  {
    id: groupActions.UPDATE_GROUP,
    title: "Update group",
    icon: imageNames.EDIT,
    size: 16,
    handler: handlers.handleUpdateGroup,
  },
  {
    id: groupActions.DELETE_GROUP,
    title: "Delete group",
    icon: imageNames.DELETE_GREY,
    size: 16,
    handler: handlers.handleDeleteGroup,
  },
];

export const getMessageActionDetails = (handlers, source = "chat_view", canDelete = true, hasTasksProject = true, isBroadcastMessage = false) => {
  const moreActionOptions = [
    {
      id: "copy_message",
      title: "Copy message",
      icon: imageNames.COPY_GREY,
      size: 16,
      handler: handlers.handleCopyMessage,
    },
  ];

  if (canDelete) {
    moreActionOptions.unshift(
      {
        id: messageActions.EDIT_MESSAGE,
        title: "Edit message",
        icon: imageNames.EDIT,
        size: 16,
        handler: handlers.handleEditMessage,
      },
      {
        id: "delete_message",
        title: "Delete message",
        icon: imageNames.DELETE_GREY,
        size: 16,
        handler: handlers.handleDeleteMessage,
      },
    );
  }

  const allActions = [
    {
      id: messageActions.ADD_REACTION,
      title: "Add reaction",
      icon: imageNames.EMOJI_GREY,
      size: 16,
      handler: handlers.handleAddReaction,
    },
    {
      id: messageActions.OPEN_THREAD,
      title: "Open thread",
      icon: imageNames.MESSAGE,
      size: 16,
      handler: handlers.handleOpenThread,
    },
    {
      id: messageActions.FORWARD_MESSAGE,
      title: "Forward message",
      icon: imageNames.FORWARD_GREY,
      size: 16,
      handler: handlers.handleForwardMessage,
    },
  ];

  if (hasTasksProject) {
    allActions.push({
      id: messageActions.CREATE_TASK,
      title: "Create task",
      icon: imageNames.ADD_TASK_GREY,
      size: 16,
      handler: handlers.handleCreateTask,
    });
  }

  allActions.push({
    id: messageActions.MORE_ACTIONS,
    title: "More actions",
    icon: imageNames.MORE_VERTICAL,
    size: 16,
    options: moreActionOptions,
  });

  if (source === "embedded_chat") {
    return allActions.filter(
      (action) => action.id !== messageActions.FORWARD_MESSAGE
        && !(isBroadcastMessage && action.id === messageActions.OPEN_THREAD)
        && !(isBroadcastMessage && action.id === messageActions.CREATE_TASK),
    );
  }

  if (source === "embedded_thread") {
    return allActions.filter(
      (action) => action.id !== messageActions.FORWARD_MESSAGE
        && action.id !== messageActions.OPEN_THREAD
        && action.id !== messageActions.CREATE_TASK,
    );
  }

  if (source === "threads" || isBroadcastMessage) {
    return allActions.filter(
      (action) => action.id !== messageActions.OPEN_THREAD
        && action.id !== messageActions.CREATE_TASK,
    );
  }

  return allActions;
};
